<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title">{{ title }}</div>
    <div class="unique-codes-list container">
      
      <div class="unique-codes-section border-bottom mt-3">
        <div class="d-flex w-100 flex-column">
          <div class="row">
            <div class="col-lg-1 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <filter-by-status @setFilterValue="setFilterByStatusValue" :execute-reset="executeReset"/>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-12">
              <div class="w-100">Date Created</div>
              <filter-by-date 
                :execute-reset="executeReset"
                @setFilterStartDate="setFilterByStartDateValue"
                @setFilterEndDate="setFilterByEndDateValue"
              />
            </div>
            <div class="col-lg-2 col-md-6 col-sm-12">
              <div class="w-100">Date Completed</div>
              <filter-by-date 
                :execute-reset="executeReset"
                filter-type="completed"
                @setFilterStartDate="setFilterByStartDateValue"
                @setFilterEndDate="setFilterByEndDateValue"
              />
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterByStatus" class="mr-1 w-100">Client</label>
                <select id="client" name="client" class="custom-select required" v-model="client_id" @change="filterSurveyOptions">
                  <option
                      v-for="(client_option, idxClientOptions) in this.client_options"
                      v-bind:value="client_option.value"
                      v-bind:key="idxClientOptions"
                  >
                      {{ client_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterByStatus" class="mr-1 w-100">Survey</label>
                <select id="survey" name="survey" class="custom-select required" v-model="survey_id">
                  <option
                      v-for="(survey_option, idxSurveyOptions) in this.survey_options"
                      v-bind:value="survey_option.value"
                      v-bind:key="idxSurveyOptions"
                  >
                      {{ survey_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-md-12 col-sm-12">
              <div class="w-100">&nbsp;</div>
              <div class="form-group float-right">
                <label for="filterByStatus" class="w-100">&nbsp;</label>
                
              </div>
            </div>
          </div>
          
          <filter-buttons @reset="reset" @filterData="filterData" :is-data-filtering="isDataFiltering" :is-filter-resetting="executeReset"/>
        </div>
      </div>
      <div class="button-container pt-1 pb-1">
        <div class="button-left">
          <div class="pr-2">
            <a href="#" @click="displayDeleteConfirmation(resetUniqueCodeIdRows,this.downloadSets,'Reset Unique Codes','Are you sure you want reset the selected unique codes ?')">
              <button type="button" class="btn btn-primary delete-card" id="ResetUniqueCodeButton" :disabled="!disableDownloadButton">
                  Reset Unique Codes 
                  <span class="ml-auto">
                  <font-awesome-icon :icon="['fas', 'undo']" />
                  </span>
              </button>
            </a>
          </div>
          <div class="pr-2">
              <a href="#" @click="displayDeleteConfirmation(deleteUniqueCodeIdRows,this.downloadSets,'Delete Unique Codes','Are you sure you want delete the selected unique codes ?')">
              <button type="button" class="btn btn-primary delete-card" id="DeleteUniqueCode" :disabled="!disableDownloadButton">
                  Delete Rows 
                  <span class="ml-auto">
                  <font-awesome-icon :icon="['fa', 'minus-circle']" />
                  </span>
              </button>
            </a>
          </div>
          <div class="pr-2">
              <a href="#" @click="openManageResponses('Delete Unique Codes','delete')">
              <button type="button" class="btn btn-primary delete-card" id="deleteUniqueCodes">
                  Delete Codes 
                  <span class="ml-auto">
                  <font-awesome-icon :icon="['fa', 'ban']" />
                  </span>
              </button>
              </a>
          </div>
        </div>
      </div>
      <div class="data-container pt-1 pb-1">
        <div class="col-12">
          <table id="unique-codes-data-table" class="table display wrap row-border table-hover" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th><input type="checkbox" id="select-all" class="ml-0" style="vertical-align:super;"></th>
                <th>Unique Code Id</th>
                <th>Client</th>
                <th>Parent Client</th>
                <th>Survey Name</th>
                <th>Email Address</th>
                <th>Unique Code</th>
                <th>Url</th>
                <th>Segment Data</th>
                <th>Status</th>
                <th>Date Created</th>
                <th>Date Completed</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div>
    <manage-unique-codes :modal-title="manageUniqueCodesTitle" :input-mode="manageUniqueCodesMode"/>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import $ from "jquery";
import jQuery from "jquery";
import axios from "axios";
import Vue from "vue";

import moment from "moment";
Vue.prototype.moment = moment;

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import TableService from "../../services/table.service";
import authHeader from "../../services/auth-header";
import ErrorService from "../../services/error.service";
import AdminService from "../../services/admin.service";
import UserService from "../../services/user.service";
import SurveyService from "../../services/survey.service";
import FilterByStatus from "../../components/filter/FilterByStatus.vue";
import FilterByDate from "../../components/filter/FilterByDate.vue";
import FilterButtons from "../../components/filter/FilterButtons.vue";
import ClientChartService from "../../services/client.chart.service";
import FilterMixins from "../../mixins/FilterMixins.vue";
import ManageUniqueCodes from "../../modals/ManageUniqueCodes.vue";
export default { 
  name: "UniqueCodesBulkData",
  mixins: [AdminMixins, DataTableMixins, FilterMixins],
  components: {
    FilterByStatus,
    FilterByDate,
    FilterButtons,
    ManageUniqueCodes
  },
  data() {
    return {
      returnMessage: "",
      title: "Unique Codes Bulk Data",
      table: {
        id: "unique-codes-data-table",
        columns: TableService.getUniqueCodesTableColumnAttributes(),
        configuration: {
          searching: true,
          responsive: false,
          dom: 'B<"top"if>rt<"bottom"lp><"clear">',
          paging: true,
          destroy: true,
          info: true,
          ordering: true,
          keys: true,
          bSort: false,
          pageLength: 50,
          buttons: [
            {
              extend: "copy",
              text: "Copy to Clipboard",
              className: "btn btn-primary"
            },
            {
              extend: "csv",
              text: "Download Codes",
              className: "btn btn-primary"
            }
          ]     
        }
      },
      client_id: 0,
      client_options: [],
      survey_id: 0,
      survey_options: [],
      survey_group_options: [],
      originalList: [],
      filteredList: [],
      isDataFiltering: false,    
      executeReset: false,
      filterByCreatedDate: false,
      filterByCreatedStartDate: new Date(2020, 0, 1),
      filterByCreatedEndDate: new Date(),    
      filterByCompletedDate: false,
      filterByCompletedStartDate: new Date(2020, 0, 1),
      filterByCompletedEndDate: new Date(),    
      filterByStatusValue: "", 
      manageUniqueCodesTitle: "Unique Codes",
      manageUniqueCodesMode: "delete",
      downloadSets: [],
      disableDownloadButton: false,
    };
  },
  methods: {
    openManageResponses(modalTitle, mode){
      this.manageUniqueCodesTitle = modalTitle;
      this.manageUniqueCodesMode = mode;
      this.$modal.show("manage-unique-codes");
    }, 
    async getTableData() {
      this.table.columns = TableService.getUniqueCodesTableColumnAttributes();
      this.getAllUniqueCodes();
    },
    async getAllUniqueCodes() {
      this.$root.processServerRequest("Loading all unique codes");
      SurveyService.getAllUniqueCodes(this.getSurveyUniqueCodesCallback, this);
    },
    getSurveyUniqueCodesCallback(response){
      this.$root.processServerResponse();
      this.originalList = response.data.data;
      this.table.data = this.originalList;
      this.client_options = ClientChartService.buildClientOptionList(this.originalList);
      this.survey_options = ClientChartService.buildSurveyOptionList(this.originalList);
      this.setupTable();
    },
    getDownloadFilename() {
      return "Survey Taker Data Template";
    },
    onFileChange: function() {
      this.importSurveyTakerDataImportFile = this.$refs.importSurveyTakerDataUpload.files[0];
    },
    async importFile() {
      if (typeof this.importSurveyTakerDataImportFile == "undefined" || this.importSurveyTakerDataImportFile == "") {
        return false;
      }
      this.$root.processServerRequest("Importing survey taker data");
      this.setModalLoading(true);
      let formData = new FormData();
      formData.append("file", this.importSurveyTakerDataImportFile);
      formData.append("userId", UserService.getUserId());

      let headers = { "Content-Type": "multipart/form-data" };
      $.extend(headers, await authHeader());

      await axios
        .post(this.baseUrl + "/api/v1/survey-summary/import-survey-taker-data", formData, { headers: headers })
        .then(response => this.importFileCallback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("SurveyService.importFile", error, "admin", this);
        });
    },
    importFileCallback: function(response) {
      this.$root.processServerResponse();
      this.setModalLoading(false);

      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.returnMessage = response.data.message;
        this.closeModal();
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    closeModal: function() {
      if (this.$refs['import-survey-taker-data-file'] != null) {
        this.$refs['import-survey-taker-data-file'].visible = false;
      }
      this.$router.go(0);
    },
    async downloadTemplate() {
      this.setupDownloadItem();
      await SurveyService.getDownloadSurveyTakerDataTemplate(this.surveyCode, this.downloadItemCallback, this);
    },
    filterSurveyOptions(){
      this.survey_options = ClientChartService.buildSurveyOptionList(this.originalList, this.client_id);
    },
    filterData: async function(){
      await this.preFilter();
      let vm = this;
      setTimeout(async () => {
        await vm.filterByStatus();
        await vm.filterByCreatedDateRange();
        await vm.filterByCompletedDateRange();
        if(this.client_id != 0){
          this.filteredList =  ClientChartService.getClientChartsByClient(this.filteredList, this.client_id, false);
        }
        if(this.survey_id != 0) {
          this.filteredList =  ClientChartService.getClientChartsBySurvey(this.filteredList, this.survey_id, false);
        }
        vm.table.data = vm.filteredList;
        vm.setupTable();
        vm.postFilter();
      }, 200);
    },    
    reset: async function(){
      await this.preReset();
      let vm = this;
      setTimeout(() => {
        vm.table.data = vm.originalList;
        vm.setupTable();
        vm.postReset();
        vm.client_id = 0;
        vm.survey_id = 0;
        vm.survey_options = ClientChartService.buildSurveyOptionList(vm.originalList);
      }, 200);
    },
    async filterByCreatedDateRange() {
      if (this.filterByCreatedDate && !this.isFilterListEmpty){
        let vm = this;
        this.filteredList = this.filteredList.filter(item => {
          let dateCreated = moment(item.dateCreated, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("YYYY-MM-DD");
          let filterByCreatedStartDate = moment(vm.filterByCreatedStartDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          let filterByCreatedEndDate = moment(vm.filterByCreatedEndDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          return dateCreated >= filterByCreatedStartDate && dateCreated <= filterByCreatedEndDate;
        });
      }
    },
    async filterByCompletedDateRange() {
      if (this.filterByCompletedDate && !this.isFilterListEmpty){
        let vm = this;
        this.filteredList = this.filteredList.filter(item => {
          let dateCompleted = moment(item.dateCompleted, "YYYY-MM-DDTHH:mm:ss.SSSZ").tz("America/Toronto").format("YYYY-MM-DD");
          let filterByCompletedStartDate = moment(vm.filterByCompletedStartDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          let filterByCompletedEndDate = moment(vm.filterByCompletedEndDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("YYYY-MM-DD");
          return dateCompleted >= filterByCompletedStartDate && dateCompleted <= filterByCompletedEndDate;
        });
      }
    },
    deselectAll: function(){
      this.downloadSets = [];
      // uncheck all rows in table
      let vm = this;
      // deselect all checkboxes in DOM at once
      $(vm.table.dataTable.rows().nodes()).find('input[name="id[]"]').prop('checked', false);
      this.disableDownloadButton = false;
    },
    addToDownloadSets: function(data){
      if (!jQuery.isEmptyObject(data)) {
        let downloadSet = new Object();
        downloadSet.id = data.surveyUniqueCodeId;
        downloadSet.surveyUniqueCodeId = data.surveyUniqueCodeId;
        this.downloadSets.push(downloadSet);
        this.disableDownloadButton = true;
      }
    },
    selectAll: function(){
      this.downloadSets = [];
      let vm = this;

      // Iterate through all rows across all pages
      vm.table.dataTable.rows({ page: 'current' }).every(function(rowIdx) {
        var $row = $( this.node() );
        let data = vm.table.dataTable.row($row).data();
        vm.addToDownloadSets(data);
        $row.find('input[name="id[]"]').prop('checked', true)
      });
      this.disableDownloadButton = true;
    },
    async deleteUniqueCodeIdRows(result) {
      let inputIds = result.map(obj => obj.surveyUniqueCodeId);
      this.$root.processServerRequest();
      this.disableDownloadButton = false;
      SurveyService.deleteUniqueCodesByList(inputIds.join(','), this.processUniqueCodesCallback, this);
    },   
    async resetUniqueCodeIdRows(result) {
      let inputIds = result.map(obj => obj.surveyUniqueCodeId);
      this.$root.processServerRequest();
      this.disableDownloadButton = false;
      SurveyService.resetUniqueCodesByList(inputIds.join(','), this.processUniqueCodesCallback, this);
    },   
    processUniqueCodesCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      this.returnMessage = response.data.message;
      this.setDisplayView(true);
      this.setModalLoading(false);      
      if (statusCode == 200) {
        this.error = false;
      } else {
        this.error = true;
        AdminService.displayErrorMessage({ text: response.data.message });
      }
      this.$router.go(0);
    },
  },
  created() {
    if (this.isAdmin) {
      this.getTableData();
      this.table.configuration.order = [
        [3, "asc"]
      ];
      this.table.configuration.columnDefs= [
        {
          targets: 0,  // The index of the column you want to make non-orderable (column 0 in this case)
          orderable: false // Disable sorting for this column
        }
      ];
    }
  },
  props: {},
  mounted() {
    let vm = this;
    $("#unique-codes-data-table tbody").on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
      var $row = $(this).closest("tr");
      var data = vm.table.dataTable.row($row).data();
      if (!jQuery.isEmptyObject(data)) {
        if (e.target.checked) {
          vm.addToDownloadSets(data);
        } else {
          let removedItem = vm.downloadSets.find(x => x.surveyUniqueCodeId == data.surveyUniqueCodeId);
          if (typeof removedItem !== "undefined") {
            vm.downloadSets.splice($.inArray(removedItem, vm.downloadSets), 1);
            if (vm.downloadSets.length == 0) {
              vm.disableDownloadButton = false;
            }
          }
        }
      }
    });
    $('#select-all').on('click', function(){
      if ($(this).is( ":checked" )) {
        vm.selectAll();
      } else {
        vm.deselectAll();
      }   
    });
  },
};
</script>
